module.exports = __webpack_public_path__ + "static/media/41_B.9a3a1a90.png";